module.exports = __webpack_public_path__ + "static/media/friedtallbirdegg.83318bb1.webp";